import {Dimensions, Platform} from 'react-native';

export * from './config';

export const isWeb = Platform.OS === 'web';
export const isAndroid = Platform.OS === 'android';
export const isIos = Platform.OS === 'ios';

export const windowWidth = Dimensions.get('window').width;
export const windowHeight = Dimensions.get('window').height;

export const endTripErrors = [
  'VehicleStationNotFound',
  'vehicle_is_not_locked',
  'StationDoesNotHaveRemainCapacity',
  'HelmetLockIsNotLocked',
  'StationIsClosed',
];
export const SITE_URL = 'https://pwa.zeero.ir/#';
export const needCodePushUpdate = true;

export const notAbleToPaymentStatuses = [
  'new_user',
  'new_user_verified',
  'inquiry_submitted',
  'inquiry_verified',
  'inquiry_rejected',
];
